import { render, staticRenderFns } from "./additional-info-tab.vue?vue&type=template&id=0647c411"
import script from "./additional-info-tab.ts?vue&type=script&lang=js&external"
export * from "./additional-info-tab.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0647c411')) {
      api.createRecord('0647c411', component.options)
    } else {
      api.reload('0647c411', component.options)
    }
    module.hot.accept("./additional-info-tab.vue?vue&type=template&id=0647c411", function () {
      api.rerender('0647c411', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/event/event-info/tabs/additional-info-tab/additional-info-tab.vue"
export default component.exports